/**
 * AdService - API client for fetching ad placements from the Company Service
 * 
 * This service fetches dynamic ad placements from the backend API.
 * No caching in this initial slice (will be added in Slice 5).
 * 
 * Requirements: 5.1, 5.3
 */

class AdService {
    /**
     * Fetches ad placements from the API for a specific placement location
     * 
     * @param {string} placementLocation - The location identifier (e.g., 'login', 'challenge_of_the_week')
     * @returns {Promise<Array>} - Array of ad placement objects, or empty array on error
     */
    async getAdPlacements(placementLocation) {
        try {
            // Use the Company Service API URL since ads are served from there
            const baseUrl = window.COMPANY_API_URL;
            
            if (typeof baseUrl === 'undefined' || baseUrl === '') {
                console.warn('COMPANY_API_URL is not set, cannot fetch ad placements');
                return [];
            }
            
            const url = `${baseUrl}/api/ad-placements/?placement_location=${encodeURIComponent(placementLocation)}`;
            
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            
            if (!response.ok) {
                console.error(`Ad API error: ${response.status} ${response.statusText}`);
                return [];
            }
            
            const data = await response.json();
            return data;
        } catch (error) {
            // Graceful degradation - return empty array on any error
            console.error(`Failed to fetch ads for ${placementLocation}:`, error);
            return [];
        }
    }
}

// Export singleton instance
export default new AdService();
